import api from './api';

const adminApi = {
  listUsers: () => api.get('/admin/users'),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.patch(`/admin/users/${id}`, data),
  resetUserPassword: (id, newPassword) => api.post(`/admin/users/${id}/reset-password`, { new_password: newPassword }),
  listBusinesses: () => api.get('/admin/businesses'),
  getUserMemberships: (userId) => api.get(`/admin/users/${userId}/memberships`),
  addMember: (businessId, data) => api.post(`/admin/businesses/${businessId}/members`, data),
  removeMember: (businessId, userId) => api.delete(`/admin/businesses/${businessId}/members/${userId}`),
  restartServer: (target = 'backend') => api.post('/admin/restart', { target }),
};

export default adminApi;
